import Swal from 'sweetalert2'
import moment from 'moment';
import Edit from './Edit/Edit.vue';

export default {
    name: 'AddUser',
    created() {
        this.GetInfo();
        //this.GetHospitalsName();
        this.GetMunicipalities();

        this.CheckLoginStatus();
    },
    components: {
        'Edit': Edit,
    },
    filters: {
        moment: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('MMMM Do YYYY');
        }
    },
    data() {
        return {
            pageNo: 1,
            pageSize: 10, 
            pages: 0,
            state: 0,
            Info: [],

            loginDetails: null,

            Municipalities: [],
            MunicipalitId: '',

            Hospitals: [],
            SelectedHospitalsId:'',
            

            ViewDilog: false,
            SelectedItem: '',


            ruleForm: {
                Id:'',
                Name: '',
            },
            rules: {
                Name: [
                    { required: true, message: 'الرجاء إدخال إسم المدينة', trigger: 'blur' },
                    { min: 3, max: 25, message: 'يجب ان يكون الطول من 3 الي 25', trigger: 'blur' },
                    { required: true, pattern: /[\u0600-\u06FF]/, message: 'الرجاء إدخال حروف العربية فقط', trigger: 'blur' }
                ],
            },
            
        };
    },
    methods: {

        CheckLoginStatus() {
            try {
                this.loginDetails = JSON.parse(localStorage.getItem('currentUser-client'));
                if (this.loginDetails == null) {
                    window.location.href = '/Login';
                }
            } catch (error) {
                window.location.href = '/Login';
            }
        },

        ChangeMunicipalities() {
            
            this.GetHospitalsName();
            this.SelectedHospitalsId = '';
            this.GetInfo();
            
        },

        refresh() {
            this.MunicipalitId = '';
            this.Hospitals = [];
            this.SelectedHospitalsId = '';
            this.GetInfo();
        },

        GetMunicipalities() {
            
            this.$blockUI.Start();
            this.$http.GetAllMunicipalities()
                .then(response => {
                    this.$blockUI.Stop();
                    this.Municipalities = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });

        },

        GetHospitalsName() {
            this.Hospitals = [];
            this.SelectedHospitalsId = '';

            this.$blockUI.Start();
            this.$http.GetHospitalsAllName(this.MunicipalitId)
                .then(response => {
                    this.$blockUI.Stop();
                    this.Hospitals = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });

        },

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            this.$blockUI.Start();
            this.$http.GetApplications(this.pageNo, this.pageSize, this.MunicipalitId, this.SelectedHospitalsId)
                .then(response => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info;
                    this.pages = response.data.count;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.pages = 0;
                });

        },

        deleteItem(id) {
            Swal.fire({
                title: 'هـل انت متأكد من عملية الحذف ؟',
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: `تأكيد العملية`,
                denyButtonText: `الغاء العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.deleteApp(id)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.FormPorgress = 100;
                            Swal.fire({
                                icon: 'success',
                                title: '..نجـاح العملية',
                                html:
                                    response.data,
                                showCancelButton: true,
                                //confirmButtonText: `حـفظ`,
                                denyButtonText: `خروج`,
                            }).then(() => {
                                this.$blockUI.Stop();
                                this.GetInfo();
                            });


                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.$notify({
                                title: 'خطأ بعملية الحذف',
                                dangerouslyUseHTMLString: true,
                                type: 'error',
                                message: err.response.data
                            });
                        });
                    return;
                }
            })
        },

        EditItem(item) {
            this.SelectedItem = item;
            this.state = 1;
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.EditCity(formName);
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

        ViewItem(item) {
            this.ViewDilog = true;
            this.SelectedItem = item;
        }

        

    }
}
